import { getAsync } from './apiHelper'
import DemoData from '../data/demoData.json';

const endpoint = process.env.VUE_APP_BACKEND;
const demoData = DemoData;

export async function getSlugDataAsync(slug) {
    if (slug !== "demo") {
        let result = await getAsync(`${endpoint}?slug=${slug}&type=getSlugData`);
        return result;
    }
    else return demoData;
}